export default function convertDataToContent(data) {
  let content = ''
  const formatMarkup = (markup) => {
    const formatted = markup?.replace(/\s/g, ' ')
    return formatted
  }

  data.map((node) => {
    const key = Object.keys(node)[0]
    switch (key) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'p':
        content += `<${key}>${formatMarkup(node[key])}</${key}>`
        break
      case 'ul':
        content += `<${key}>`
        node.ul.map((item) => {
          content += `<li>${formatMarkup(item.li)}</li>`
          return ''
        })
        content += `</${key}>`
        break
      case 'ol':
        content += `<${key}>`
        node.ol.map((item) => {
          content += `<li>${formatMarkup(item.li)}</li>`
          return ''
        })
        content += `</${key}>`
        break
      case 'markup':
        content += node[key]
        break
    }

    return ''
  })

  return content
}
